import React from 'react';
import { Text } from '@src/atoms/Text';
import { ILegoElem } from '../Lego';
import { COMMON_LINKS } from '@src/consts/links';
import { FeedbackFormCheckboxLink } from './_OfferLink/FeedbackFormCheckboxLink';
import {
  FeedbackFormMarketingCheckboxLink
} from "@src/molecules/FeedbackForm/_MarketingOfferLink/FeedbackFormMarketingCheckboxLink";

export const DEFAULT_ENV = {
  element: 'feedback_dialog',
  action: 'open',
};

export const TARIFF_ICONS = {
  pro: 'rocketSmallPro',
  start: 'rocketSmallStart',
  grow: 'rocketSmallGrow',
} as const;

export const NAME_INPUT: ILegoElem = {
  id: 'name',
  input: {
    label: 'Имя',
    size: 'lg',
  },
  validators: {
    dataType: 'STRING',
    required: true,
    max: 50,
  },
};
export const PHONE_NUMBER_INPUT: ILegoElem = {
  id: 'phone',
  input: {
    label: 'Номер телефона',
    size: 'lg',
  },
  validators: {
    dataType: 'STRING',
    required: true,
    phone: true,
  },
};
export const EMAIL_INPUT: ILegoElem = {
  id: 'email',
  input: {
    label: 'Корпоративный email',
    number: true,
    size: 'lg',
  },
  validators: {
    dataType: 'STRING',
    required: true,
    email: true,
  },
};

export const BASIC_BIO_ELEM: ILegoElem[] = [NAME_INPUT, PHONE_NUMBER_INPUT, EMAIL_INPUT];

export const PESONAL_INFO_CHECKBOX: ILegoElem = {
  id: 'personalInfo',
  checkbox: {
    id: 'checkbox',
  },
  boxWrap: {
    marginLeft: 4,
  },
  content: (
    <FeedbackFormCheckboxLink
      id="personalInfoLink"
      href={COMMON_LINKS.PRIVACY.href}
      target={COMMON_LINKS.PRIVACY.target}
    >
      политикой обработки персональных данных
    </FeedbackFormCheckboxLink>
  ),
  validators: {
    dataType: 'BOOLEAN',
    required: true,
    custom: [
      {
        name: 'checkbox',
        test: (value) => {
          if (value) return true;
          return false;
        },
        message: 'Для продолжения необходимо согласие',
      },
    ],
  },
};

export const USER_AGREEMENT_CHECKBOX: ILegoElem = {
  id: 'offerEducation',
  checkbox: {
    id: 'checkbox',
  },
  boxWrap: {
    marginLeft: 4,
  },
  content: (
    <FeedbackFormCheckboxLink
      id="userAgreementLink"
      href={COMMON_LINKS.OFFER_EDUCATION.href}
      target={COMMON_LINKS.OFFER_EDUCATION.target}
    >
      условиями пользовательского соглашения
    </FeedbackFormCheckboxLink>
  ),
  validators: {
    dataType: 'BOOLEAN',
    required: true,
    custom: [
      {
        name: 'checkbox',
        test: (value) => {
          if (value) return true;
          return false;
        },
        message: 'Для продолжения необходимо согласие',
      },
    ],
  },
};

export const MAILING_AGREEMENT_CHECKBOX: ILegoElem = {
  id: 'dispatch',
  checkbox: {
    id: 'checkbox',
  },
  boxWrap: {
    marginLeft: 4,
  },
  content: (
    <FeedbackFormMarketingCheckboxLink
      id="userMarketingOfferLink"
      href={COMMON_LINKS.MARKETING_OFFER.href}
      target={COMMON_LINKS.MARKETING_OFFER.href}
    >
      новости, обновления и полезные материалы
    </FeedbackFormMarketingCheckboxLink>
  ),
  validators: {
    dataType: 'BOOLEAN',
  },
};

export const COMPANY_TITLE: ILegoElem = {
  id: 'company',
  input: {
    label: 'Наименование компании',
    number: true,
    size: 'lg',
  },
  validators: {
    dataType: 'STRING',
  },
};
